/*
 * Table of contents for the policies page.
 *
 * Clicking an entry is handled by the browser through the anchor href, so the
 * jump still works with JavaScript disabled. This file only adds the active
 * highlight, which follows whichever policy is currently under the header.
 *
 * Important: above 990px this theme does not scroll the window. base.css sets
 * `html, body { height: 100dvh; overflow: hidden }` and makes `.page-wrapper`
 * the scrolling element. So `window.scrollY` stays at 0, scroll events never
 * reach `window`, and `document.documentElement.scrollHeight` is only about one
 * viewport tall. Anything measuring the page through `window` therefore has to
 * go through the real scroller instead.
 */
(function () {
  /* Returns the element that actually scrolls, or null when the document does. */
  function getScroller() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return null;
    var overflowY = getComputedStyle(wrapper).overflowY;
    var scrolls = overflowY === 'auto' || overflowY === 'scroll';
    if (scrolls && wrapper.scrollHeight > wrapper.clientHeight + 1) return wrapper;
    return null;
  }

  function isAtBottom() {
    var el = getScroller();
    if (el) return el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
    var doc = document.documentElement;
    return window.scrollY + window.innerHeight >= doc.scrollHeight - 2;
  }

  function init(root) {
    if (!root || root.dataset.tocInit === 'true') return;
    root.dataset.tocInit = 'true';

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-toc-link]'));
    if (!links.length) return;

    var targets = links
      .map(function (link) {
        var id = (link.getAttribute('href') || '').replace('#', '');
        var el = id ? document.getElementById(id) : null;
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    function headerOffset() {
      var raw = getComputedStyle(document.body).getPropertyValue('--header-height');
      var value = parseInt(raw, 10);
      return isNaN(value) ? 0 : value;
    }

    function update() {
      /*
        getBoundingClientRect is measured against the viewport, so it reports the
        same numbers whether the window or .page-wrapper is doing the scrolling.
        A policy becomes current once its top passes just under the header.
      */
      var line = headerOffset() + 24;
      var current = targets[0];

      targets.forEach(function (item) {
        if (item.el.getBoundingClientRect().top <= line) current = item;
      });

      /*
        At the very end of the page the final policy can be too short to ever
        reach the line, so promote it once the scroller has bottomed out.
      */
      if (isAtBottom()) current = targets[targets.length - 1];

      targets.forEach(function (item) {
        var active = item === current;
        item.link.classList.toggle('is-active', active);
        if (active) item.link.setAttribute('aria-current', 'true');
        else item.link.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    /*
      Scroll events do not bubble, but they can be captured. Listening on the
      document in the capture phase picks up scrolling from .page-wrapper on
      desktop and from the document on mobile, without having to know which is
      in play or re-bind when the viewport crosses the breakpoint.
    */
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    update();
    window.requestAnimationFrame(update);
  }

  function boot() {
    document.querySelectorAll('[data-policies-toc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
